import React from 'react';
import { FaGoogle ,FaFacebookF} from 'react-icons/fa';
import { api } from '../api';
import './SocialLogin.css';

const SocialLogin = () => {
    const ap = 'http://localhost:8000/api/'; 

    const handleGoogleLogin = () => {
        window.location.href = `${ap}auth/google`;
    };
    const handleFacebookLogin = () => {
        window.location.href = `${ap}auth/facebook`;
    };

    return (
        <div className="social-login">
            <div className="social-divider">
                <span>Ou continuer avec</span>
            </div>

            <div className="social-buttons">
                <button 
                    className="social-btn google-btn" 
                    onClick={handleGoogleLogin}
                    type="button"
                >
                    <FaGoogle className="social-icon" />
                    <span>Google</span>
                </button>

                <button 
                    className="social-btn facebook-btn" 
                    onClick={handleFacebookLogin}
                    type="button"
                >
                    <FaFacebookF className="social-icon" />
                    <span>Facebook</span>
                </button>
            </div>
        </div>
    );
};

export default SocialLogin;